'use client'

import * as React from 'react'

import * as TabsPrimitive from '@radix-ui/react-tabs'

import { cn } from '~/utils/tailwind-utils'

export const TabsTrigger = ({
  ref,
  isDisabled,
  className,
  ...props
}: Omit<
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>,
  'disabled'
> & {
  isDisabled?: boolean
} & {
  ref?: React.RefObject<React.ElementRef<typeof TabsPrimitive.Trigger> | null>
}) => (
  <TabsPrimitive.Trigger
    ref={ref}
    disabled={isDisabled}
    className={cn(
      '-mb-px border-b-2 px-1 pb-2 text-base font-medium outline-none data-[state=active]:border-black data-[state=inactive]:border-transparent data-[state=inactive]:text-secondary data-[state=active]:dark:border-white',
      isDisabled
        ? 'cursor-not-allowed opacity-40'
        : 'data-[state=inactive]:hover:text-primary',
      className,
    )}
    {...props}
  />
)
